import { useEffect, useState } from 'react';

export interface IUseTablePaginationOptions {
  searchParams: URLSearchParams;
  setSearchParams: (parms: URLSearchParams) => void;
  count: number;
  defaultLimit?: number;
}

export function useTablePagination({
  searchParams,
  setSearchParams,
  count,
  defaultLimit = 10,
}: IUseTablePaginationOptions) {
  const limit = Number(searchParams.get('limit')) || defaultLimit;
  const offset = Number(searchParams.get('offset')) || 0;
  const [page, setPage] = useState(offset / limit);

  const handlePageChange = (_: React.MouseEvent<HTMLButtonElement> | null, page: number): void => {
    setPage(page);
  };

  const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    searchParams.set('limit', String(event.target.value));
    setSearchParams(searchParams);
  };

  useEffect(() => {
    searchParams.set('offset', String(page * limit));
    setSearchParams(searchParams);
  }, [page, limit, searchParams, setSearchParams]);

  return {
    page,
    limit,
    count,
    setPage,
    handlePageChange,
    handleRowsPerPageChange,
  };
}
